import { FunctionalComponent } from 'preact';
import {
  useSelector,
  useCheckoutContext,
} from '@primer-io/shared-library/contexts';
import VaultedPaymentMethod from '../components/VaultedPaymentMethod';
import VaultMenu from '../components/VaultMenu';
import { AnimatePresence } from '../utils/AnimatePresence';
import { CheckoutOptions } from '../types';

type Props = Record<string, never>;

const CheckoutVaultScene: FunctionalComponent<Props> = ({ children }) => {
  const vault = useSelector((s) => s.vault);
  const labels = useSelector((s) => s.translation);
  const { options } = useCheckoutContext();

  const vaultOptions = options as CheckoutOptions;

  ///////////////////////////////////////////
  // Render
  ///////////////////////////////////////////

  const renderEditButton = () => {
    return (
      !(vaultOptions.vault?.deletionDisabled ?? false) && (
        <div
          id='primer-checkout-vault-edit-button'
          data-testId='CheckoutVaultScene.vaultEditButton'
          class='PrimerCheckout__savedPaymentMethodActions'
        >
          <VaultMenu />
        </div>
      )
    );
  };

  return (
    <div id='primer-checkout-vault-methods'>
      <div
        id='primer-checkout-vault'
        class='PrimerCheckout__sceneElement PrimerCheckout__savedPaymentMethods'
      >
        <div class='PrimerCheckout__savedPaymentMethods__title'>
          <div class='PrimerCheckout__label PrimerCheckout__label--muted PrimerCheckout__savedPaymentMethods__label'>
            {labels?.previouslyUsed}
          </div>
          {renderEditButton()}
        </div>

        <AnimatePresence>
          {vault.items.map((vaultedItem) => (
            <VaultedPaymentMethod
              key={vaultedItem.id}
              vaultedItem={vaultedItem}
            />
          ))}
        </AnimatePresence>
      </div>

      {children}

      <div></div>
    </div>
  );
};

export default CheckoutVaultScene;
